import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";
import { formQKeys } from "@hooks/queries/forms/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

export const useDeleteFormConfig = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (serviceId: string) => {
      return api.delete(`form-configurations/${serviceId}`);
    },
    onSuccess: (_, serviceId) => {
      showSuccessNotification({
        title: "success",
        message: "form-configuration-deleted-success",
      });

      // Invalidate the query so the UI reflects that the form is gone
      queryClient.invalidateQueries({
        queryKey: formQKeys.config(serviceId),
      });
    },
    onError: (res: any) => {
      console.error("[From Delete Form Config]", res);
      handleErrors(res, "mutation");
    },
  });
};
